import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

const GAME_TAG = 'bingo'
const ACT_NAME = 'cold_boot_activity_bingo_v3'

export enum stateEnum {
  noUse = 0,
  using,
  canUse,
  expired,
}
enum typeEnum {
  //  1骰子皮肤 2棋子皮肤
  dice = 1,
  chessman,
}
export interface game_skin_type {
  id: number
  icon: string
  title: string
  state: stateEnum
  tag: string
  expire_day: number
  type: typeEnum
  pid: number
}
export enum missionStatus {
  goDo = 0,
  received,
  canGet,
  expired,
}
export enum rewardEnum {
  silverCoin = 7,
  skin,
}
export enum BUTTON_STATE {
  hide = 0,
  goToDo = 1,
  showPrize = 2,
}
export interface IReward {
  img_url: string
  reward_cnt: number
  is_box: boolean
  reward_type?: rewardEnum
  reward_msg?: string
}
interface MissionActivityItemSt {
  mission_id: number
  reward: IReward
  status: missionStatus
  desc: string
  target: number
  current: number
}
export interface RankItem {
  rank: number
  score: number
  name: string
  image: string
  button_state: number
  mid: number
}
interface CommonRank {
  list: Array<RankItem>
  my_rank_info: RankItem
  rewards: Array<IReward>
  button_state: BUTTON_STATE
}
export interface IRoom {
  room_id: number
  title: string
  cover: string
  scheme: string
}

export enum PageTypeEnum {
  task = 'task',
  bag = 'bag',
}

// 背包列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=90611208
export const knapsack_list = createAsyncThunk(
  'BingoColdBoot_knapsack_list',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<Pick<InitialStateType, 'list'>>>(
      '/gamestore/common/knapsack_list',
      {
        ...store.getState().env.deviceinfo,
        activity_name: ACT_NAME,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 冷启活动任务列表 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92448285
export const getTaskList = createAsyncThunk(
  'BingoColdBoot_common_activity_detail',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        common_activity_detail?: {
          list?: Array<MissionActivityItemSt>
        }
        activity_time?: string
      }>
    >(
      '/gamestore/common/common_activity_detail',
      {
        ...store.getState().env.deviceinfo,
        activity_name: ACT_NAME,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)
// 领取任务奖励 http://wiki.xunlei.cn/pages/viewpage.action?pageId=92448499
export const common_activity_reward = createAsyncThunk(
  'BingoColdBoot_common_activity_reward',
  async (arg: {mission_id: number; room_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        err_msg: string
        common_activity?: {
          List?: Array<MissionActivityItemSt>
        }
        reward?: IReward
      }>
    >('/gamestore/common/common_activity_reward', {
      ...store.getState().env.deviceinfo,
      ...arg,
      activity_name: ACT_NAME,
    })
    return resp.data.data
  }
)
// 使用皮肤
export const use_game_skin = createAsyncThunk(
  'BingoColdBoot_use_mall_game_skin',
  async (arg: {room_id: number; pid: number; type: typeEnum}, store: any) => {
    const resp = await http.post<HiyaRes<{err_msg: string}>>(
      '/gamestore/common/use_mall_game_skin',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
        game_tag: GAME_TAG,
        from: 'cold_boot_activity',
      }
    )
    return resp.data.data
  }
)

// 冷启活动任务去完成
export const cold_boot_goto_complete = createAsyncThunk(
  'BingoColdBoot_cold_boot_goto_complete',
  async (arg: {room_id: number}, store: any) => {
    const resp = await http.post<
      HiyaRes<{
        scheme: number
        err_msg: string
      }>
    >('/gamestore/common/game_mission_goto_complete', {
      ...store.getState().env.deviceinfo,
      ...arg,
      game_tag: GAME_TAG,
      from: 'cold_boot_activity',
    })
    return resp.data.data
  }
)

interface InitialStateType {
  // 背包列表
  list?: Array<{game_skin?: game_skin_type}>
  // 任务列表
  common_activity_detail?: {
    list?: Array<MissionActivityItemSt>
  }
  activity_time?: string
  taskCanGet?: boolean
}
const initialState: InitialStateType = {}

export const BingoColdBootSlice = createSlice({
  name: 'BingoColdBoot',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(knapsack_list.fulfilled, (state, action) => {
        Object.assign(state, action.payload)
      })
      .addCase(getTaskList.fulfilled, (state, action) => {
        Object.assign(state, {
          ...action.payload,
          taskCanGet:
            action.payload?.common_activity_detail?.list?.findIndex(
              (item) => item.status === missionStatus.canGet
            ) >= 0,
        })
      })
      .addCase(common_activity_reward.fulfilled, (state, action) => {
        if (action.payload.common_activity && !action.payload.err_msg) {
          Object.assign(state, {
            common_activity_detail: action.payload.common_activity,
          })
        }
      })
  },
})
export default BingoColdBootSlice.reducer
export const BingoColdBootActions = BingoColdBootSlice.actions
